<template>
  <div v-if="filterCourses(search, courses).length > 0">
    <h2 class="headline ">
      Published Courses
      <!-- <v-btn text icon color="grey" x-small="">
        <v-icon small="">mdi-help</v-icon>
      </v-btn> -->
    </h2>
    <!-- Draft List -->
    <v-row class="holder">
      <v-col class="col-12" v-if="courses.length == 0 && loaded">
        <slot name="missing">
          <p class="title">
            There are no pending courses at this time. Wait for a draft to be
            published.
          </p>
        </slot>
        <slot name="notfound"></slot>
      </v-col>
      <v-col
        class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
        v-for="item in filterCourses(search, courses)"
        v-bind:key="item.title"
      >
        <a-l-publishedcard
          :course="item"
          @edit="onEdit"
          @delivery="deliveryRedirect"
          @responses="responseRedirect"
          @users="userRedirect"
          @reject="setStatus(false, course)"
          @copy="copyCourse"
        >
        </a-l-publishedcard>
      </v-col>
    </v-row>
    <!-- End Draft List -->
    <!-- Delete Confirmation Modal -->
    <a-confirm-modal :dialog="showDeleteConfirm">
      <template slot="headline">
        Are you sure you want to delete "{{ deleteName }}"
      </template>
      <template slot="body">
        This action cannot be undone, once a course is deleted it CANNOT be
        recovered.
      </template>
      <template slot="actions">
        <v-btn color="grey" dark depressed @click="onDeleteReject"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn depressed color="red lighten-2" dark @click="onDeleteConfirm"
          >Yes, Delete Forever</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Delete Confirmation Modal -->
    <!-- Error Modal -->
    <a-confirm-modal :dialog="cannotDelete">
      <template slot="headline">
        Could not delete the course!
      </template>
      <template slot="body">
        Could not delete the selected course. You must withdraw the course in
        order to delete it.
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn depressed color="blue" dark @click="cannotDelete = false"
          >Dismiss</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Error Modal -->
  </div>
</template>
<style scoped>
.holder {
  padding-bottom: 100px;
}
</style>
<script>
import publishedCard from "./publishedcard";
import service from "@/services/index.js";
import confirm from "@/components/confirmation-modal";
import services from "@/services/index.js";

export default {
  components: {
    "a-l-publishedcard": publishedCard,
    "a-confirm-modal": confirm
  },
  data: () => ({
    loaded: false,
    courses: [],
    show: false,
    chopping_block: null,
    showDeleteConfirm: false,
    cannotDelete: false
  }),
  computed: {
    deleteName() {
      if (!this.chopping_block) {
        return "";
      }
      return this.chopping_block.name || "None";
    }
  },
  props: {
    search: {
      type: String,
      default: () => ""
    }
  },
  methods: {
    async copyCourse(course) {
      this.$store.commit("setLoading", true);

      try {
        const id = course && course._id ? course._id : null;
        if (!id) {
          return;
        }
        const clone = await services.course.clone({
          target: id
        });
        console.log("got clone", clone);
        this.$emit("update");
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
    deliveryRedirect() {
      return this.$router.push({ name: "coursedelivery" });
    },
    userRedirect(course) {
      return this.$router.push({
        name: "usersbycourse",
        params: { courseid: course._id }
      });
    },
    responseRedirect(course) {
      return this.$router.push({
        name: "responsesbycourse",
        params: { courseid: course._id }
      });
    },
    filterCourses(title, source) {
      return source.filter(course =>
        String(course.name)
          .trim()
          .toLowerCase()
          .includes(
            String(title)
              .trim()
              .toLowerCase()
          )
      );
    },
    /**
     * Handles loading of the initial courses.
     */
    async onLoad() {
      try {
        this.$store.commit("setLoading", true);
        this.courses = await service.course.get({
          status: "published",
          type: "publisher"
        });
        this.$store.commit("setLoading", false);
      } catch (err) {
        console.log("Pending", err);
        this.$store.commit("setLoading", false);
      }
      this.loaded = true;
      console.log(this.drafcoursests);
    },
    /**
     * Handles routing to the editor.
     */
    onEdit(course) {
      try {
        this.$ga.event({
          eventCategory: "dashboard-courses",
          eventAction: "edit-published",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.log(err);
      }
      this.$router.push({
        name: "coursebuilder-editor-published",
        params: { id: course._id }
      });
    },
    /**
     * Handles updating a courses status of pending approval.
     */
    async togglePublished(course) {
      try {
        this.$store.commit("setLoading", true);

        await service.draft.update({
          id: course._id,
          coursedoc: { pendingApproval: course.pendingApproval ? false : true }
        });
        //no need to reload entire list... just update this entry.
        course.pendingApproval = course.pendingApproval ? false : true;
        console.log("Pending");
      } catch (err) {
        console.error(err);
      }
      this.$store.commit("setLoading", false);
    },
    /**
     * Preps the modal that will ask if this course should be deleted or not.
     */
    toggleDelete(course) {
      // this.$store.commit("setLoading", true);
      this.chopping_block = course;
      this.showDeleteConfirm = true;
    },
    async onDeleteConfirm() {
      this.showDeleteConfirm = false;
      this.$store.commit("setLoading", true);
      try {
        if (!this.chopping_block) {
          this.onDeleteReject();
          throw "Invalid Removal";
        }
        await service.draft.delete({ id: this.chopping_block._id });
      } catch (err) {
        console.error(err);
        this.cannotDelete = true;
      }
      this.$store.commit("setLoading", false);
      this.onLoad();
    },
    onDeleteReject() {
      this.chopping_block = null;
      this.showDeleteConfirm = false;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
